import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import "../../routes/intel/controls/controls.scss";
import NewPieChart from "../../core/charts/newPie";
import { TAB_DATA_SOURCE, unifiedIsoCountries } from "../../core/dictionary/global";
import { getComplianceUrl } from "../../utils/complianceUrl";
import LoaderImg from "../../../src/assets/images/loader.gif";
import LocalStorageService from "../../core/services/local-storage.service";
import { globalGetApiUrl } from "../../utils/globalBaseUrl";
import { getApiUrl } from "../../utils/baseUrl";
import { toast } from "react-toastify";
import ReactCountryFlag from "react-country-flag";
import NoSearchDataComponent from "../country-components/no-search-data";
import { trademoTrackingEvents } from "../../core/global/trademo-tracking";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import { generateTrackingObject } from "../../core/global/global-country-functions";
import { globalAPIDictionary } from "../../../src/core/global/global-country-dictionary";
import { useSelector } from "react-redux";

const globalApiEndPoints = globalAPIDictionary;
const ControlsComponent = (props) => {
  const localStorageService = LocalStorageService.getService();
  let productArray = localStorage.getItem("productArr");
  let userPlan = JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan;
  let searchKey = new URLSearchParams(window.location.search).get("searchKey");
  let searchedItem = new URLSearchParams(window.location.search).get("searchedItem");
  const parent_product_mapping = useSelector((state) => state.userDetails.userData.parent_product_mapping);
  const ref = useRef(null);
  const { imports, exports } = TAB_DATA_SOURCE;
  const [countryDataSource, setCountryDataSource] = useState([]);
  const [dataSource, setDataSource] = useState("");
  const [country, setCountry] = useState("");
  const [controlsList, setControlsList] = useState([]);
  const [embargoesList, setEmbargoesList] = useState([]);
  const [id, setId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    if (props.id) {
      apiCallingHandler("ZZ");
    } else {
      apiCallingHandler();
    }
  }, [props.id]);

  // product_hscode
  const apiCallingHandler = async (cty, dtrc) => {
    setLoader(true);
    const searchUrlParams = window.location.search;
    let id = props.id || props.id === 0 ? props.id : new URLSearchParams(searchUrlParams).get("id");
    if (id || id === 0) {
      setId(id);
      let country = cty || new URLSearchParams(searchUrlParams).get("country");
      let dataSource = dtrc || new URLSearchParams(searchUrlParams).get("datasource") || new URLSearchParams(searchUrlParams).get("type") + "s";
      try {
        let {
          data: { data },
        } = await axios.get(`${globalApiEndPoints.getUserComplianceHookData}?id=${Number(id)}`);
        let {
          data: { data: countryData },
        } = await axios.post(`${globalApiEndPoints.intelSearchHooksSummary}`, {
          hs_code_list: data.hs_code_list,
          trade_direction: dataSource,
        });
        let { data: controlsList } = await axios.post(`${globalApiEndPoints.intelSearchHooksCountryData}`, {
          country: [country],
          trade_direction: dataSource,
          hs_code_list: data.hs_code_list,
        });

        if (countryData.length) {
          let findIndex = countryData.findIndex((item) => item.country.toLowerCase() === country.toLowerCase());
          if (findIndex > 6) {
            let value = countryData.splice(findIndex, 1);
            countryData.splice(1, 0, value[0]);
          }
        }
        setCountryDataSource(countryData);
        setCountry(country);
        setDataSource(dataSource);
        if (Object.keys(controlsList).length) {
          let controlsListClone = controlsList.countrol_list.map((item) => ({ ...item, key: item.key, value: item.doc_count, legendKey: item.key.slice(0, 40), marketShare: Number(((item.doc_count / controlsList.total_control_count) * 100).toFixed(2)) })).slice(0, 10);
          let embargoesListClone = controlsList.embargoes_list.map((item) => ({ ...item, key: item.key, value: item.doc_count, marketShare: Number(((item.doc_count / controlsList.total_embargoes_count) * 100).toFixed(2)), legendKey: item.key.slice(0, 40) })).slice(0, 10);
          setControlsList(controlsListClone);
          setEmbargoesList(embargoesListClone);
          setLoader(false);
        }
      } catch (err) {}
    }
  };

  const controlsNavigation = () => {
    assignProduct();
  };

  const assignProduct = () => {
    setLoader(true);
    const requestObj = {
      productName: "gtm",
      is_free_trial: true,
      dataSource: "product",
      noOfDays: 14,
    };
    let productData = JSON.parse(JSON.stringify(parent_product_mapping));
    let data = productData.find((item) => item.product_name === "gtm");
    if (data.is_org_access && data.is_subscribed === false) {
      toast.success("Your organization already has a subscription. Please contact your admin for access.");
      setLoader(false);
    } else if (data.is_org_access === false && data.is_subscribed === false) {
      axios.post(globalGetApiUrl("auth/extendAccount"), requestObj).then((res) => {
        if (res) {
          setTimeout(() => {
            let token = localStorageService.getAccessToken();
            let session = localStorageService.getSessionID();
            let expiry = localStorageService.getExpiryDate() || localStorageService.getSessionExpiryDate();
            let url = getComplianceUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + `&P=trade-compliance&Tab=controls&id=${id}&dataSource=${dataSource}`;
            window.location.href = url;
          }, 2000);
        }
      });
    } else {
      let token = localStorageService.getAccessToken();
      let session = localStorageService.getSessionID();
      let expiry = localStorageService.getExpiryDate() || localStorageService.getSessionExpiryDate();
      let url = getComplianceUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + `&P=trade-compliance&Tab=controls&id=${id}&dataSource=${dataSource}`;
      window.location.href = url;
    }
  };

  if (loader) {
    return (
      <div className="loader-block">
        <img className="emailLoader" src={LoaderImg} alt="description of gif" />
      </div>
    );
  }

  const getInTouchHandler = () => {
    let userData = JSON.parse(localStorage.getItem("userData")).session_id;
    const params = {
      planId: userData ? userData : null,
      countries: "gtm",
      key: "Intel Hooks Landing Page",
    };
    axios
      .get(getApiUrl("notifySales"), { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again later !!!");
      });
  };
  return (
    <div className="">
      <div className="controls_container_free_trial_container w-75">
        <div>
          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687950013/intel/icons/Lightning-alt_mlxyoq.svg" alt="..." className="img-fluid ml-2 controls-bolt" />{" "}
        </div>
        <div className="">
          <div>
            <p className="controls-main-heading m-0">We have access to Controls for 80+ countries, 440+ Government Authorities and 750K+.Import & Export Compliance data entities which would help you to make your supply chain more compliant.</p>
          </div>
        </div>
        {showButton ? (
          <div>
            {!!props.userDetail && !!props.userDetail.parent_product_mapping && props.userDetail.parent_product_mapping.filter((item) => item.product_name === "gtm")[0].days_left < 0 ? (
              <button onClick={getInTouchHandler} className="btn btn-primary trademo-new-btn free-trial-btn">
                Get In Touch
              </button>
            ) : !!productArray && productArray !== "undefined" && productArray.includes("gtm") ? (
              <button onClick={controlsNavigation} className="btn btn-primary trademo-new-btn free-trial-btn">
                View All Controls
              </button>
            ) : (
              <button
                onClick={() => {
                  trademoTrackingEvents(trackingEventDictionary.controlStartFreeTrialClick, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", userPlan));
                  controlsNavigation();
                }}
                className="btn btn-primary trademo-new-btn free-trial-btn">
                Start your Free Trial
              </button>
            )}
          </div>
        ) : null}
      </div>
      <div className="controls-horizontal-line"></div>
      <div className="mt-4 text-center">
        <div className="d-flex align-items-center justify-content-center">
          <div
            onClick={() => {
              setDataSource(imports);
              apiCallingHandler(country, imports);
            }}
            className={dataSource === imports ? "controls-datasource-tab-active" : "controls-datasource-tab"}>
            Import Controls and Embargoes for {!!searchKey && searchKey.includes("product") ? "Product Keyword" : "HS Code"}
          </div>
          <div
            onClick={() => {
              setDataSource(exports);
              apiCallingHandler(country, exports);
            }}
            className={dataSource === exports ? "controls-datasource-tab-active" : "controls-datasource-tab"}>
            Export Controls and Embargoes for {!!searchKey && searchKey.includes("product") ? "Product Keyword" : "HS Code"}
          </div>
        </div>
      </div>
      <div className="text-center">
        <h5 className="mt-5 controls_sub_heading">What are Controls and Embargoes?</h5>
        <p className="controls_sub_content mb-1">Controls refer to specific legislations that restrict or measure the flow of products, technologies to and from a country.</p>
        <p className="controls_sub_content mb-3">
          We have found the following controls and embargoes for the {!!searchKey && searchKey === "product_description" ? "product" : "HS Code"} <b>{searchedItem ? searchedItem : props.hsCode ? props.hsCode : ""}</b>
        </p>
      </div>
      <div className="controls-horizontal-line"></div>
      <div className="row mt-4">
        <div className="col-3">
          <div className="mx-2 controls_select_country_main_container">
            <p className="controls_select_country_heading">Select Country</p>
            <div className="controls_select_country_container">
              {countryDataSource.map((item, index) => (
                <div
                  key={item.country}
                  id={`country${index}`}
                  ref={ref}
                  onClick={() => {
                    setShowButton(item.control_count > 0 ? true : false);
                    setCountry(item.country);
                    apiCallingHandler(item.country, dataSource);
                  }}
                  className={country.toLowerCase() === item.country.toLowerCase() ? "controls-country-card-active" : "controls-country-card"}>
                  <div className="d-flex align-items-start">
                    {item.country === "ZZ" ? <img className="multi-country-logo" src="https://res.cloudinary.com/drzta9shk/image/upload/v1696592256/intel/icons/universal_search_icon_r8t2r8.svg" /> : <ReactCountryFlag className="mt-1 mr-1 trademo-search-flag" countryCode={item.country === "ZZ" ? "" : item.country} svg />}
                    <p className="m-0 controls_country_name">{unifiedIsoCountries[item.country]}</p>
                  </div>
                  <p className="m-0 controls_country_details">
                    {item.control_count ? item.control_count : ""} {item.control_count ? "controls" : ""} {item.control_count && item.embargoes_count ? "&" : ""} {item.embargoes_count ? item.embargoes_count : ""} {item.embargoes_count ? "Embargoes" : ""}{" "}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-9">
          {controlsList.length || embargoesList.length ? (
            <div className="row">
              {controlsList.length ? (
                <div className="col-6">
                  <div className="d-flex justify-content-between mb-2">
                    <p className="m-0 controls_graph_heading">
                      {dataSource} Controls on {!!searchKey && searchKey.includes("product") ? "Product Keyword" : "HS Code"}
                    </p>
                    {/* <p className="m-0 controls_graph_sample">View Sample <span></span></p> */}
                  </div>
                  <div className="controls_pie_graph_container">
                    {controlsList.length ? <NewPieChart disabaleClick={true} id={"1"} piegraphData={controlsList} /> : <></>}
                    <div className="text-center">
                      {showButton ? (
                        <button
                          onClick={() => {
                            trademoTrackingEvents(trackingEventDictionary.controlViewAllExportImportControlsEmbargoes, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", userPlan));
                            controlsNavigation();
                          }}
                          className="controls_graph_button mt-4">
                          View All <span className="text-capitalize">{dataSource}</span> Controls
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
              {embargoesList.length ? (
                <div className="col-6">
                  <div className="d-flex justify-content-between mb-2">
                    <p className="m-0 controls_graph_heading">
                      {dataSource} Embargoes on {!!searchKey && searchKey.includes("product") ? "Product Keyword" : "HS Code"}
                    </p>
                    {/* <p className="m-0 controls_graph_sample">View Sample</p> */}
                  </div>
                  <div className="controls_pie_graph_container">
                    {embargoesList.length ? <NewPieChart disabaleClick={true} id={"2"} piegraphData={embargoesList} /> : <></>}
                    <div className="text-center">
                      {showButton ? (
                        <button
                          onClick={() => {
                            trademoTrackingEvents(trackingEventDictionary.controlViewAllExportImportControlsEmbargoes, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", userPlan));
                            controlsNavigation();
                          }}
                          className="controls_graph_button mt-4">
                          View All <span className="text-capitalize">{dataSource}</span> Embargoes
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ) : (
            <NoSearchDataComponent content={"No Controls Found"} />
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ControlsComponent);
